import { BookOpen, ChevronRight } from 'lucide-react';

/**
 * Rappel « notion(s) à choisir » en tête de la thématique (25/10/2026).
 *
 * Une personne abonnée 6 ou 12 mois (ou qui a acheté un pack) a des notions à choisir,
 * mais on ne le lui disait que dans l'onglet Notions et dans le mail d'annonce : sans
 * passer par ce lien, elle ne le voyait pas. L'encart reprend la mise en page de
 * l'encart parrainage (une ligne en mobile) et mène à l'onglet Notions. Pas de bouton
 * pour le masquer : il disparaît de lui-même une fois les notions choisies.
 */
export default function NotionsAChoisirEncart({ offerCredits = 0, packCredits = 0, onOpen }) {
    const credits = offerCredits + packCredits;
    if (credits < 1) return null;
    const quoi = credits > 1 ? `${credits} notions à choisir` : 'une notion à choisir';
    const origine = offerCredits > 0 && packCredits > 0 ? 'avec ton abonnement et ton pack'
        : offerCredits > 0 ? (offerCredits > 1 ? 'offertes avec ton abonnement' : 'offerte avec ton abonnement')
        : 'avec ton pack';

    return (
        <aside className="parrainage-encart parrainage-encart--notions" aria-label="Notions à choisir">
            <button type="button" className="parrainage-encart__mini" onClick={onOpen}>
                <BookOpen size={16} /> <span><b>Il te reste {quoi}</b></span> <ChevronRight size={16} />
            </button>
            <span className="parrainage-encart__icon" aria-hidden="true"><BookOpen size={20} /></span>
            <div className="parrainage-encart__text">
                <span className="parrainage-encart__kicker">Notions à la carte</span>
                <strong>Il te reste {quoi}, {origine}.</strong>
                <span>Une fiche de cours et 20 QCM, à toi pour toujours. Ouvre la notion de ton choix et touche « Choisir cette notion ».</span>
            </div>
            <button type="button" className="parrainage-encart__cta" onClick={onOpen}>
                Voir les notions <ChevronRight size={16} />
            </button>
        </aside>
    );
}
